import React from 'react'
import "./SectionSix.css"
const SectionSix = () => {
  return (
    <div className='SectionSix'>
            <img src="https://ableton-production.imgix.net/about/photo-8.jpg?crop=right&dpr=2&fit=crop&h=410&ixjsv=1.1.3&q=50&w=683" alt="" />
        
            <h2>We’re really proud of the work we’ve done so far. But there’s so much more to come. If you’d like to be a part of it, please join us. <span>See Latest Jobs &#8811;</span></h2>
        
    </div>
  )
}

export default SectionSix